/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'link': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M13.122 18.665a6.682 6.682 0 009.44-.402l3.041-3.312a6.682 6.682 0 10-9.842-9.039l-.94 1.025a1 1 0 101.472 1.352l.94-1.024a4.682 4.682 0 116.897 6.333l-3.04 3.312a4.682 4.682 0 01-7.454-.74 1 1 0 00-1.71 1.037c.32.529.72 1.02 1.196 1.458zm4.87-5.912a6.682 6.682 0 00-9.44.402L5.51 16.467a6.682 6.682 0 009.843 9.039l.94-1.025a1 1 0 00-1.473-1.352l-.94 1.024a4.682 4.682 0 01-6.897-6.333l3.042-3.312a4.682 4.682 0 017.453.74 1 1 0 101.71-1.038 6.683 6.683 0 00-1.196-1.457z" _fill="#EF7812"/>'
  }
})
